module.exports = __webpack_public_path__ + "static/template_options_4_day-2a378efd6d129ca9b604d9d01d62693f.png";